/* eslint-disable no-console */
import React, { useState, useCallback, useRef, useEffect } from 'react'
import { IMaskInput } from 'react-imask'
import { FlexByRow, XDivider, YDivider, useTheme } from 'irmlib/styles'
import styled from 'styled-components'
import { setTheme, themeSelector, lightTheme, darkTheme } from 'irmlib/themes'
import { setBusy, clearBusy, openInformationDialog, openGeneralDialog } from 'irmlib/containers'
import { TextFieldBorderless, Chip, Label, StopWatch, ToolTip, MultiSelectWithCheckboxes, MenuButton, Autocomplete, SelectTheme, ThemeButton, CheckBox, RadioGroup, Select, Slider, Switch, TextField, TextFieldOutlined, Menu, DateAndTime, ClickableSvgIcon, TextFieldWithValidation, InputAdornment } from 'irmlib/components/Controls'
import { VolumeDown, VolumeUp, MoreVert, Info } from 'irmlib/icons'
import { useMergeState, usePageHandler } from 'irmlib/hooks'
import { get, uiGet } from 'irmlib/http'
import PageHeader from '../AppControl/PageHeader'
import SearchIcon from '../../icons/svg/search'
import { successToast, warningToast, errorToast, infoToast } from '../../common/functions'
import UserRolePermission from '../../components/Controls/UserRolePermission'
import { userRoleAdmin, userRoleUser, userRoleSuperUser } from '../../common/constants'
import { validateAndGetAccountLevel1 } from '../../services/skpApi/accountLevel1'

const HomeContainer = styled.div`
`

const MultiSelectWithCheckboxesContainer = styled.div`
  width: 200px; 
`

const HomeBodyContainer = styled(FlexByRow)`
  justify-content: center;
`

const countries = [
  { label: 'TUVALU', code: 'TV' },
  { label: 'UGANDA', code: 'UG' },
  { label: 'UKRAINE', code: 'UA' },
  { label: 'UNITED ARAB EMIRATES', code: 'AE' },
  { label: 'UNITED KINGDOM', code: 'GB' },
  { label: 'UNITED STATES', code: 'US' },
]

const radioItems = [
  { value: 'Radio1', label: 'demo.radio1' },
  { value: 'Radio2', label: 'demo.radio2' },
  { value: 'Radio3', label: 'demo.radio3' }
]

const selectItems = [
  { value: '10', label: 'demo.select1' },
  { value: '20', label: 'demo.select2' },
  { value: '30', label: 'demo.select3' },
  { value: '40', label: 'demo.select4' },
  { value: '50', label: 'demo.select5' }
]

const menuItems = [
  { value: '10', label: 'demo.menuItem1' },
  { value: '20', label: 'demo.menuItem2' },
  { value: '30', label: 'demo.menuItem3' },
]


const PartitionDivider = () =>
  <XDivider width='50px' />

const VerticalDivider = () =>
  <YDivider height='10px' />

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

const service = async () => {
  const response = await get('https://jsonplaceholder.typicode.com/todos')
  return response
}

const MemoryLeakComponent = () => {
  const [, setCount] = useState(0)
  useEffect(() => {
    setTimeout(() => { console.log('***** MemoryLeakComponent demonstrates "Can\'t perform a React state update on an unmounted component."'); setCount(10) }, 2000)
    return () => console.log('MemoryLeakComponent dismount')
  }, [])
  return (
    <div />
  )
}

const MemoryLeakComponentFixed = () => {
  const [, setState] = useMergeState({})
  useEffect(() => {
    setTimeout(() => { console.log('***** MemoryLeakComponentFixed demonstrates no "Can\'t perform a React state update on an unmounted component." error.'); setState({ count: 10 }) }, 1000)
    return () => console.log('MemoryLeakComponentFixed dismount')
  }, [])
  return (
    <div />
  )
}

const ChildComponent = props => {
  console.log('************** ChildComponent renders everytime *************')
  return (
    // eslint-disable-next-line react/prop-types
    <ThemeButton color='primary' onClick={props.onClick}>
      demo.childComponent
    </ThemeButton>
  )
}

let key = 0
const initialState = { start: 'true', testData: 'stale', data: null }
const ComponentDemo = () => {
  console.log('enter ComponentDemo')
  const theme = useTheme()
  console.log('********************************* theme', theme)
  const refTextFieldWithValidation = useRef()
  const refStopWatch = useRef()
  const [value1, setValue1] = useState(0)
  const [value2, setValue2] = useState(0)
  const [value3, setValue3] = useState(0)
  const [state, setState, getState] = useMergeState(initialState)
  console.log('ComponentDemo after useMergeState', state)
  const changeTheme = () => {
    console.log('****** Shows 1 render for 2 state change call.')
    setState({ done1: true })
    setState({ done2: true })
    setValue3(10)
    console.log('changeTheme state', state, getState(), value3)
    if (themeSelector() === lightTheme) {
      setTheme(darkTheme)
    } else {
      setTheme(lightTheme)
    }
    console.log('****** Shows 1 render for 2 state change call end.')
    clearBusy('100')
  }
  // eslint-disable-next-line no-unused-vars
  const startChangeTheme = () => {
    setTimeout(changeTheme, 2000)
    setBusy('100')
  }
  const openModal = () => {
    openInformationDialog({ message: 'To subscribe to this website, please enter your email address here. We will send updates occasionally.' })
  }

  const openDialog = () => {
    openGeneralDialog({ dividers: true, closeX: true, title: <Label color='primary'>demo.sampleDialogTitle</Label>, message: 'To subscribe to this website, please enter your email address here. We will send updates occasionally.' })
  }
  const testHttp = async () => {
    console.log('testHttp')
    await uiGet({ service: 'https://jsonplaceholder.typicode.com/todos' })

    // This shows 1 render for each setValue
    console.log('')
    console.log('****** Shows 1 render for each state change call.')
    console.log('call setValue1')
    setValue1(value1 + 1)
    console.log('call setValue2')
    setValue2(value2 + 1)
    console.log('****** Shows 1 render for each state change call end.')
    console.log('')
  }

  const testButton = () => {
    console.log('')
    console.log('****** Shows value1 after setValue1 is not the new state.')
    console.log(`value1=${value1}`)
    console.log(`call setValue1 and change to value1=${value1 + 1}.`)
    setValue1(value1 + 1)
    console.log(`value1 after setValue1, note that it did not change, value1=${value1}.`)
    console.log('****** Shows value1 after setValue1 is not the new state end.')
    console.log('')
    setValue2(value2 + 1)
  }

  const testButton1Render = () => {
    // This shows 1 render for each setValue
    console.log('')
    console.log('****** Shows 1 render for both state change call.')
    console.log('call setValue1')
    setValue1(value1 + 1)
    console.log('call setValue2')
    setValue2(value2 + 1)
    console.log('****** Shows 1 render for both state change call end.')
    console.log('')
  }
  const onChange = useCallback(() => {

  }, [])

  const handleData = data => {
    console.log('')
    console.log('****** Shows the stale state problem, state is not correct with testData="stale" but getState() is with testData="fresh2".')
    console.log('handleData callback stale state, state.testData=', state.testData)
    console.log('handleData callback getState, resolves stale state, getState().testData=', getState().testData)
    console.log('****** Shows the stale state problem end.')
    console.log('')
    setState({ data })
  }

  useEffect(() => {
    refStopWatch.current.start()
    console.log('')
    console.log('****** Demonstrate setState callbacks.')
    setState({ testData: 'fresh' }, state => {
      console.log('')
      console.log('***** callback', state)
    })
    console.log('call getState', getState())
    setState({ testData: 'fresh2' }, state => {
      console.log('')
      console.log('***** callback2', state)
    })
    console.log('call getState2', getState())
    console.log('****** Demonstrate setState callbacks end.')
    console.log('')
    refTextFieldWithValidation.current.focus()
  }, [])

  useEffect(() => {
    if (state.data) {
      setState({ data: null })
    }
  }, [state.data])

  const onClickChild = () => {

  }

  const displaySuccessToast = () => {
    successToast({ message: 'The operation was a success.', title: 'Template' })
  }
  const displayWarningToast = () => {
    warningToast({ message: 'This is a warning message.', title: 'Template' })
  }
  const displayErrorToast = () => {
    errorToast({ message: 'This is an error message.', title: 'Template' })
  }
  const displayInfoToast = () => {
    infoToast({ message: 'This is an info message.', title: 'Template' })
  }

  const getOptionLabel = useCallback(entry => {
    return entry.label
  }, [])

  const getOptionSelected = useCallback((entry, value) => {
    return entry.code === value.code
  }, [])

  // usePageHandler/usePageHandler should only be called once. Below is just for showing different ways of calling it.
  // For usePageHandler, the parent of the page needs to be position: relative.

  usePageHandler({ service: 'https://jsonplaceholder.typicode.com/todos', callback: handleData })
  usePageHandler({ service, callback: handleData })

  const handleAccountLevel = () => {
    console.log('Account Level', validateAndGetAccountLevel1('AMER', 'TEST'))
  }
  let mask = '#a#aaaa/#:#,Aa.-9'
  const mapObj = {
    a: '[a]',
    9: '[9]',
    A: 'A'
  }
  mask = mask.replace(/a|9/gi, function(matched) {
    return mapObj[matched]
  })

  return (
    <>
      {console.log('render Home')}
      <HomeContainer>
        <PageHeader>
          demo.gCPComponentDemo
        </PageHeader>
        <YDivider height='40px' />
        {state.data ? <MemoryLeakComponent data={state.data} /> : null}
        {state.data ? <MemoryLeakComponentFixed data={state.data} /> : null}
        <HomeBodyContainer>
          <div>
            test mask input
            <IMaskInput 
              name="test"
              mask={mask}
              lazy= {false}
              definitions={{
                '#': /[0-9]/,
                A: /[0-9 a-z A-Z]/,
                a: /[0-9 a-z A-Z]?/,
                9: /[0-9]?/,
              }}
            />
            <StopWatch ref={refStopWatch} />
            <VerticalDivider />
            <BottomPaddedButton size='small' variant='contained' color='primary' onClick={handleAccountLevel} noTranslate>
              Account Level 1
            </BottomPaddedButton>
            <BottomPaddedButton size='small' variant='contained' color='primary' onClick={openModal}>
              demo.openInfoModal
            </BottomPaddedButton>
            <BottomPaddedButton variant='contained' color='primary' onClick={openDialog}>
              demo.openGeneralModal
            </BottomPaddedButton>
            <BottomPaddedButton disabled variant='contained' color='primary' onClick={testHttp}>
              demo.testHttp
            </BottomPaddedButton>
            <UserRolePermission allowsTo={[userRoleUser, userRoleAdmin, userRoleSuperUser]}>
              <BottomPaddedButton variant='contained' color='primary'>
                demo.firebase
              </BottomPaddedButton>
            </UserRolePermission>
            <BottomPaddedButton color='primary' onClick={testButton}>
              <span>{`TextButton ${value1} ${value2}`}</span>
            </BottomPaddedButton>
            <BottomPaddedButton color='primary' variant='outlined' onClick={() => { }}>
              demo.outlineButtonIP
            </BottomPaddedButton>
            <BottomPaddedButton color='default' variant='contained' onClick={testButton1Render}>
              demo.defaultButton
            </BottomPaddedButton>
            <BottomPaddedButton color='default'>
              demo.defaultTextButton
            </BottomPaddedButton>
            <BottomPaddedButton variant='outlined' color='default'>
              demo.defaultOutlineButton
            </BottomPaddedButton>
            <ChildComponent onClick={onClickChild} />
            <VerticalDivider />
            <CheckBox label='demo.checkbox' />
            <CheckBox label='demo.checkbox' disabled />
            <CheckBox checkColor='green' label='demo.customCheckbox' />
          </div>
          <PartitionDivider />
          <div>
            <RadioGroup label='demo.radioButtons' items={radioItems} />
            <VerticalDivider />
            <Select label='demo.selectDemo' items={selectItems} />
            <VerticalDivider />
            <MultiSelectWithCheckboxesContainer>
              <MultiSelectWithCheckboxes label='demo.multiSelectWithCheckboxes' items={selectItems} />
            </MultiSelectWithCheckboxesContainer>
            <VerticalDivider />
            <Slider label='demo.volume' leftIcon={VolumeDown} rightIcon={VolumeUp} />
            <VerticalDivider />
            <Switch label='demo.switchDemo' />
            <VerticalDivider />
            <TextField label='demo.textField' key={++key} onChange={onChange} />
            <YDivider height='20px' />
            <TextFieldOutlined 
              label='demo.textFieldOutlined' 
              endAdornment={
                <InputAdornment position='end'>
                  <Info />
                </InputAdornment>
              } 
            />
            <VerticalDivider />
            <div>Borderless Text Field Below</div>
            <TextFieldBorderless />
            <VerticalDivider />
            <Menu
              onSelect={value => { console.log(`menu item value=${value}`) }}
              items={menuItems}
            >
              <ThemeButton
                variant='contained'
                color='primary'
                aria-haspopup='true'
              >
                demo.menuDemo
              </ThemeButton>
            </Menu>
            <VerticalDivider />
            <MenuButton
              buttonIcon={<MoreVert />}
              onSelect={value => console.log(`menu item value=${value}`)}
              items={menuItems}
            />
          </div>
          <PartitionDivider />
          <div>
            <ToolTip
              message='This is a tooltip. This is a tooltip. This is a tooltip. This is a tooltip. This is a tooltip. This is a tooltip. '
              noTranslate
              style={{ height: '21px' }}
            >
              <Info />
            </ToolTip>
            <Autocomplete
              label='demo.searchableDropdown'
              onChange={() => { }}
              options={countries}
              getOptionLabel={getOptionLabel}
              getOptionSelected={getOptionSelected}
            />
            <VerticalDivider />
            <DateAndTime id='DateAndTime' label='demo.dateTimeDemo' />
            <VerticalDivider />
            {/* Svg icons given to us by UX team */}
            <ClickableSvgIcon onClick={() => console.log('click')}><SearchIcon /></ClickableSvgIcon>
            <SearchIcon scale={0.7} />
            <SearchIcon scale={0.7} fill='red' />
            <VerticalDivider />
            <div>
              <TextFieldWithValidation fixedErrorMessageFieldHeight ref={refTextFieldWithValidation} validator={value => {
                if (value.length > 20) {
                  return 'demo.validateFieldErrorMsg'
                }
                return ''
              }} />
            </div>
            <BottomPaddedButton variant='outlined' onClick={() => refTextFieldWithValidation.current.validate()}>
              demo.validateField
            </BottomPaddedButton>
            <BottomPaddedButton variant='outlined' onClick={() => refTextFieldWithValidation.current.clear()}>
              demo.clearField
            </BottomPaddedButton>
            <BottomPaddedButton variant='outlined' onClick={displaySuccessToast}>
              demo.successToast
            </BottomPaddedButton>
            <BottomPaddedButton variant='outlined' onClick={displayWarningToast}>
              demo.warningToast
            </BottomPaddedButton>
            <BottomPaddedButton variant='outlined' onClick={displayErrorToast}>
              demo.errorToast
            </BottomPaddedButton>
            <BottomPaddedButton variant='outlined' onClick={displayInfoToast}>
              demo.infoToast
            </BottomPaddedButton>
            <SelectTheme />
            <VerticalDivider />
            <Chip label='demo.chipLabel' size='small' backgroundColor='green' textColor='white' fontSize='10px' />
          </div>
        </HomeBodyContainer>
      </HomeContainer>
    </>
  )
}

export default ComponentDemo